import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Box, Icon, Tooltip } from '@chakra-ui/react'

export const GridToolTip = () => {
  return (
    <Tooltip
      label={
        <Box p='10px'>
          <Box>
            Click on the image to create corners of the area. Four corners would
            be connected to form an area used for tailgate detection or AI
            Operator. You should draw two areas: A red area outside the entrance
            and a green area inside the entrance. You can drag the corners to
            adjust their position. Area edges cannot intersect each other.
          </Box>
          <Box mt='5px'>Tips:</Box>
          <Box>
            ○ When creating tailgating area, try to alight its edges with
            something symmetrical in the image (i.e., cabinet, floor tile, or
            any baseline of measurement)
          </Box>
          <Box>
            ○ Leave a space between the Red and Green, this will reduce false
            positives.
          </Box>
        </Box>
      }
      minW='500px'
      placement='right'
      shouldWrapChildren
    >
      <Icon as={HiOutlineInformationCircle} boxSize='24px' color='#33344B' />
    </Tooltip>
  )
}
